import React from 'react';

interface SpinnerSvgProps {
  theme: {
    primary: string;
    secondary: string;
  };
}

export const createSpinnerInner = (theme: SpinnerSvgProps['theme']): React.ReactNode => (
  <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.42857 44.0001C5.42857 22.6977 22.6976 5.42871 44 5.42871"
      stroke={theme.primary}
      strokeWidth="10"
      strokeLinecap="round"
    />
    <path
      d="M82.5714 44.0004C82.5714 65.3028 65.3024 82.5718 44 82.5718"
      stroke={theme.secondary}
      strokeWidth="10"
      strokeLinecap="round"
    />
  </svg>
);

export const createSpinnerOuter = (theme: SpinnerSvgProps['theme']): React.ReactNode => (
  <svg
    width="130"
    height="130"
    viewBox="0 0 130 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M65 125C31.8629 125 5 98.1371 5 65"
      stroke={theme.primary}
      strokeWidth="10"
      strokeLinecap="round"
    />
    <path
      d="M65 4.99999C98.1371 5 125 31.8629 125 65"
      stroke={theme.secondary}
      strokeWidth="10"
      strokeLinecap="round"
    />
  </svg>
);
